import { render } from "./CommentTab.vue?vue&type=template&id=c871d526"
import script from "./CommentTab.vue?vue&type=script&lang=js"
export * from "./CommentTab.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommentTab.vue?vue&type=style&index=0&id=c871d526&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__